import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=744be3b7&scoped=true"
import script from "./productItem.vue?vue&type=script&lang=js"
export * from "./productItem.vue?vue&type=script&lang=js"
import style0 from "./productItem.vue?vue&type=style&index=0&id=744be3b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744be3b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744be3b7')) {
      api.createRecord('744be3b7', component.options)
    } else {
      api.reload('744be3b7', component.options)
    }
    module.hot.accept("./productItem.vue?vue&type=template&id=744be3b7&scoped=true", function () {
      api.rerender('744be3b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/children/productItem.vue"
export default component.exports